<template>
    <div class="single-header">
        <secondary-header :title="lang('Genealogy')" backRoute="default" :menuButton="false"></secondary-header>

        <main>
            <div class="container">
                <div class="row justify-content-center digital-card">
                    <div class="col-lg-10 py-3 px-1">
                        <div class="d-flex mb-3 px-2">
                            <div class="d-flex">
                                <img :src="merchant_branch.branch_logo ? merchant_branch.branch_logo : merchant.merchant_logo" alt="" class="logo m-auto" style="max-width: 100%; max-height: 7rem;">
                            </div>
                            <div class="flex-fill pl-2">
                                <h4 class="text-center ">{{ merchant_branch.name }}</h4>
                                <input name="searching" id="searching" v-model="searching" class="form-control mb-2" placeholder="Name 1 / Name 2">
                            </div>
                        </div>
                        <div class="genealogy-list">
                            <div class="level-1">
                                <div v-for="gen in genealogies" :key="gen.id" class="level-1">
                                    <div class="card my-2" @click="openTree(gen.id)" :style="'background-color:'+ (gen.is_current_user ? genealogy_settings.color_self : (genealogy_settings['color_level_'+ gen.level])) +';'">
                                        <div class="card-body p-2">
                                            <template v-for="(text_content, i) in genealogy_settings.list_text_contents">
                                                <span v-if="gen[text_content.detail_field]" :key="i" class="list-details">
                                                    <span v-if="text_content.detail_field_rename">{{ text_content.detail_field_rename }}:</span> {{ gen[text_content.detail_field] }}<span class="show-if-not-last-child">;</span>&nbsp;
                                                </span>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div v-if="!state.loading_resource && genealogies.length == 0" class="text-center py-5">{{ lang('No data available') }}</div> -->
                    </div>
                </div>
            </div>

            <loader v-if="state.loading || (state.loading_resource && this.searching == '')" />
        </main>
    </div>
</template>

<script>
export default {
    props: ['merchant_member_id'],

    data() {
        return {
            genealogies: {},
            genealogy_current: undefined,
            genealogy_settings: {},
            merchant: {
                merchant_logo: this.$route.query.merchant_logo_url,
            },
            merchant_branch: {
                branch_logo: this.$route.query.merchant_logo_url,
            },

            searching: '',
        }
    },

    watch: {
        searching: function(newVal) {
            this.getResource()
        }
    },

    methods: {
        getResource() {
            this.$set(this.state, 'loading_resource', true)
            axios.post(this.GLOBAL.API_BASE_URL +"digital-card/"+ this.merchant_member_id + "/genealogy-list", {
                    searching: this.searching
                })
                .then(response => {
                    this.genealogies = response.data.genealogy_data
                    this.genealogy_current = response.data.genealogy_current
                    this.genealogy_settings = response.data.genealogy_settings
                    this.merchant = response.data.merchant
                    this.merchant_branch = response.data.merchant_branch
                })
                .catch(error=>defaultErrorManagement(error.response)) //to catch the errors if any
                .finally(() => this.$set(this.state, 'loading_resource', false))
        },

        openTree(genealogy_id) {
            var query_string = this.$route.query
            query_string.genealogy_id = genealogy_id
            this.$router.push({ name:'digital-card.genealogy-tree', params: {
                merchant_member_id: this.merchant_member_id},
                query: query_string
            })
        }
    },

    created() {
        this.getResource()
    },

    beforeRouteLeave(to, from, next) {
        to.params.member_active_index = this.$route.query.member_active_index
        next()
    }
}
</script>

<style lang="scss" scoped>
    .text-LEFT {
        display: flex;
        div {
            margin-right: 1rem;
        }
    }
    .text-RIGHT {
        display: flex;
        justify-content: right;
        div {
            margin-left: 1rem;
        }
    }
    .text-CENTRE {
        display: flex;
        justify-content: center;
        div {
            margin-left: 1rem;
            margin-right: 1rem;
        }
    }
    .text-JUSTIFY {
        display: flex;
        > div:not(:first-child):not(:last-child) {
            margin: auto;
        }
        > div:first-child {
            margin-right: auto;
        }
        > div:last-child {
            margin-left: auto;
        }
    }

    .card {
        position: relative;
        z-index: 12;

        .gender {
            position: absolute;
            top: 0;
            right: 0.4rem;

            &.Male {
                color: #3490dc;
            }
            &.Female {
                color: #ff94f0;
            }
        }
    }

    .list-details:last-child {
        .show-if-not-last-child {
            display: none;
        }
    }
    
</style>